import { BASE_PATH as p, BaseAPI as R, operationServerMap as b } from "../base.js";
import { DUMMY_BASE_URL as M, assertParamExists as C, createRequestFunction as u, serializeDataIfNeeded as x, setSearchParams as V, toPathString as O } from "../common.js";
import A from "axios";
var P = function(e) {
  return {
    cashierMemberAssets: async (t, o, c, r = {}) => {
      C("cashierMemberAssets", "memberId", t);
      const a = "/cashier/members/{memberId}/assets".replace("{memberId}", encodeURIComponent(String(t))), s = new URL(a, M);
      let n;
      e && (n = e.baseOptions);
      const l = {
        method: "GET",
        ...n,
        ...r
      }, i = {}, h = {};
      o !== void 0 && (h.shopId = o), c !== void 0 && (h.scanGrantToken = c), V(s, h);
      let m = n && n.headers ? n.headers : {};
      return l.headers = {
        ...i,
        ...m,
        ...r.headers
      }, {
        url: O(s),
        options: l
      };
    },
    cashierMemberConvert: async (t, o = {}) => {
      C("cashierMemberConvert", "memberId", t);
      const c = "/cashier/members/{memberId}/convert".replace("{memberId}", encodeURIComponent(String(t))), r = new URL(c, M);
      let a;
      e && (a = e.baseOptions);
      const s = {
        method: "POST",
        ...a,
        ...o
      }, n = {};
      V(r, {});
      let l = a && a.headers ? a.headers : {};
      return s.headers = {
        ...n,
        ...l,
        ...o.headers
      }, {
        url: O(r),
        options: s
      };
    },
    cashierMemberCouponPack: async (t, o, c, r, a, s = {}) => {
      C("cashierMemberCouponPack", "memberId", t);
      const n = "/cashier/members/{memberId}/coupon-pack".replace("{memberId}", encodeURIComponent(String(t))), l = new URL(n, M);
      let i;
      e && (i = e.baseOptions);
      const h = {
        method: "GET",
        ...i,
        ...s
      }, m = {}, d = {};
      o !== void 0 && (d.status = o), c !== void 0 && (d.page = c), r !== void 0 && (d.pageSize = r), a !== void 0 && (d.shopId = a), V(l, d);
      let S = i && i.headers ? i.headers : {};
      return h.headers = {
        ...m,
        ...S,
        ...s.headers
      }, {
        url: O(l),
        options: h
      };
    },
    cashierMemberResolveQrcode: async (t, o = {}) => {
      C("cashierMemberResolveQrcode", "resolveQrCodeRequest", t);
      const c = new URL("/cashier/members/resolve-qrcode", M);
      let r;
      e && (r = e.baseOptions);
      const a = {
        method: "POST",
        ...r,
        ...o
      }, s = {}, n = {};
      s["Content-Type"] = "application/json", V(c, n);
      let l = r && r.headers ? r.headers : {};
      return a.headers = {
        ...s,
        ...l,
        ...o.headers
      }, a.data = x(t, a, e), {
        url: O(c),
        options: a
      };
    },
    cashierMemberSearch: async (t, o, c, r = {}) => {
      const a = new URL("/cashier/members/search", M);
      let s;
      e && (s = e.baseOptions);
      const n = {
        method: "GET",
        ...s,
        ...r
      }, l = {}, i = {};
      t !== void 0 && (i.phone = t), o !== void 0 && (i.keyword = o), c !== void 0 && (i.shopId = c), V(a, i);
      let h = s && s.headers ? s.headers : {};
      return n.headers = {
        ...l,
        ...h,
        ...r.headers
      }, {
        url: O(a),
        options: n
      };
    }
  };
}, v = function(e) {
  const t = P(e);
  return {
    async cashierMemberAssets(o, c, r, a) {
      var s, n;
      const l = await t.cashierMemberAssets(o, c, r, a), i = (s = e == null ? void 0 : e.serverIndex) !== null && s !== void 0 ? s : 0, h = (n = b["MemberCashierApi.cashierMemberAssets"]) === null || n === void 0 || (n = n[i]) === null || n === void 0 ? void 0 : n.url;
      return (m, d) => u(l, A, p, e)(m, h || d);
    },
    async cashierMemberConvert(o, c) {
      var r, a;
      const s = await t.cashierMemberConvert(o, c), n = (r = e == null ? void 0 : e.serverIndex) !== null && r !== void 0 ? r : 0, l = (a = b["MemberCashierApi.cashierMemberConvert"]) === null || a === void 0 || (a = a[n]) === null || a === void 0 ? void 0 : a.url;
      return (i, h) => u(s, A, p, e)(i, l || h);
    },
    async cashierMemberCouponPack(o, c, r, a, s, n) {
      var l, i;
      const h = await t.cashierMemberCouponPack(o, c, r, a, s, n), m = (l = e == null ? void 0 : e.serverIndex) !== null && l !== void 0 ? l : 0, d = (i = b["MemberCashierApi.cashierMemberCouponPack"]) === null || i === void 0 || (i = i[m]) === null || i === void 0 ? void 0 : i.url;
      return (S, I) => u(h, A, p, e)(S, d || I);
    },
    async cashierMemberResolveQrcode(o, c) {
      var r, a;
      const s = await t.cashierMemberResolveQrcode(o, c), n = (r = e == null ? void 0 : e.serverIndex) !== null && r !== void 0 ? r : 0, l = (a = b["MemberCashierApi.cashierMemberResolveQrcode"]) === null || a === void 0 || (a = a[n]) === null || a === void 0 ? void 0 : a.url;
      return (i, h) => u(s, A, p, e)(i, l || h);
    },
    async cashierMemberSearch(o, c, r, a) {
      var s, n;
      const l = await t.cashierMemberSearch(o, c, r, a), i = (s = e == null ? void 0 : e.serverIndex) !== null && s !== void 0 ? s : 0, h = (n = b["MemberCashierApi.cashierMemberSearch"]) === null || n === void 0 || (n = n[i]) === null || n === void 0 ? void 0 : n.url;
      return (m, d) => u(l, A, p, e)(m, h || d);
    }
  };
}, k = function(e, t, o) {
  const c = v(e);
  return {
    cashierMemberAssets(r, a) {
      return c.cashierMemberAssets(r.memberId, r.shopId, r.scanGrantToken, a).then((s) => s(o, t));
    },
    cashierMemberConvert(r, a) {
      return c.cashierMemberConvert(r.memberId, a).then((s) => s(o, t));
    },
    cashierMemberCouponPack(r, a) {
      return c.cashierMemberCouponPack(r.memberId, r.status, r.page, r.pageSize, r.shopId, a).then((s) => s(o, t));
    },
    cashierMemberResolveQrcode(r, a) {
      return c.cashierMemberResolveQrcode(r.resolveQrCodeRequest, a).then((s) => s(o, t));
    },
    cashierMemberSearch(r = {}, a) {
      return c.cashierMemberSearch(r.phone, r.keyword, r.shopId, a).then((s) => s(o, t));
    }
  };
}, B = class extends R {
  cashierMemberAssets(e, t) {
    return v(this.configuration).cashierMemberAssets(e.memberId, e.shopId, e.scanGrantToken, t).then((o) => o(this.axios, this.basePath));
  }
  cashierMemberConvert(e, t) {
    return v(this.configuration).cashierMemberConvert(e.memberId, t).then((o) => o(this.axios, this.basePath));
  }
  cashierMemberCouponPack(e, t) {
    return v(this.configuration).cashierMemberCouponPack(e.memberId, e.status, e.page, e.pageSize, e.shopId, t).then((o) => o(this.axios, this.basePath));
  }
  cashierMemberResolveQrcode(e, t) {
    return v(this.configuration).cashierMemberResolveQrcode(e.resolveQrCodeRequest, t).then((o) => o(this.axios, this.basePath));
  }
  cashierMemberSearch(e = {}, t) {
    return v(this.configuration).cashierMemberSearch(e.phone, e.keyword, e.shopId, t).then((o) => o(this.axios, this.basePath));
  }
};
export {
  B as MemberCashierApi,
  P as MemberCashierApiAxiosParamCreator,
  k as MemberCashierApiFactory,
  v as MemberCashierApiFp
};

//# sourceMappingURL=member-cashier-api.js.map